(function () {
  'use strict';
  const selectors = 'button[name="checkout"],button[name="add"],.additional-checkout-buttons,.shopify-payment-button,.m-sticky-addtocart';
  // Pure geometry: start at the normal launcher position and move above every
  // overlapping purchase control, including stacked express-payment buttons.
  function safeTop(top, left, size, obstacles) {
    const gap = 12;
    for (let i = 0; i <= obstacles.length; i++) {
      const hits = obstacles.filter(r => left < r.right + gap && left + size > r.left - gap && top < r.bottom + gap && top + size > r.top - gap);
      if (!hits.length) return top;
      top = Math.min(...hits.map(r => r.top)) - gap - size;
    }
    return top;
  }
  let queued = false;
  function update() {
    queued = false;
    const root = document.querySelector('#tidio-chat')?.shadowRoot;
    const button = root?.querySelector('#button.chat-closed');
    if (!button || !window.matchMedia('(max-width:767px)').matches) return;
    button.style.removeProperty('--rehair-chat-lift');
    button.style.removeProperty('--rehair-chat-visibility');
    const rect = button.getBoundingClientRect();
    const obstacles = [...document.querySelectorAll(selectors)].map(el => {
      if (getComputedStyle(el).visibility === 'hidden') return null;
      return el.getBoundingClientRect();
    }).filter(r => r && r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight);
    const top = safeTop(rect.top, rect.left, rect.height, obstacles);
    // If purchase controls occupy the entire available column, briefly hide
    // only the closed launcher; never obscure payment or alter an open chat.
    const viewportTop = window.visualViewport?.offsetTop || 0;
    if (top < viewportTop + 12) button.style.setProperty('--rehair-chat-visibility', 'hidden');
    else button.style.setProperty('--rehair-chat-lift', Math.max(0, rect.top - top) + 'px');
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }
  function install() {
    const root = document.querySelector('#tidio-chat')?.shadowRoot;
    if (!root) return false;
    let style = root.getElementById('rehair-mobile-chat-clearance');
    if (!style) { style = document.createElement('style'); style.id = 'rehair-mobile-chat-clearance'; root.appendChild(style); }
    style.textContent = `@media(max-width:767px){
      #button.chat-closed{top:auto!important;bottom:calc(96px + env(safe-area-inset-bottom,0px) + var(--rehair-chat-lift,0px))!important;right:12px!important;left:auto!important;width:44px!important;height:44px!important;transform:none!important;visibility:var(--rehair-chat-visibility,visible)!important}
      #button.chat-closed .sidebar-content{display:none!important}
      #button.chat-closed #button-body{position:relative!important;top:auto!important;bottom:auto!important;left:auto!important;right:auto!important;width:44px!important;height:44px!important;border-radius:50%!important}
    }`;
    new MutationObserver(schedule).observe(root, { childList:true, subtree:true, attributes:true, attributeFilter:['class'] });
    new MutationObserver(schedule).observe(document.body, { childList:true, subtree:true });
    document.addEventListener('scroll', schedule, {passive:true, capture:true});
    window.addEventListener('resize', schedule, {passive:true});
    window.visualViewport?.addEventListener('resize', schedule, {passive:true});
    window.visualViewport?.addEventListener('scroll', schedule, {passive:true});
    schedule();
    return true;
  }
  let attempts = 0;
  if (!install()) {
    const timer = setInterval(() => { if (install() || ++attempts >= 60) clearInterval(timer); }, 1000);
  }
})();
